/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



(function () {




  document.addEventListener("click", function(e){

  const link = e.target.closest(".stamped-pagination a");
  if(!link) return;

  const modal = document.getElementById("reviews-modal");
  if(!modal || modal.style.display !== "block") return;

  setTimeout(function(){

    const modalInner = modal.querySelector(".reviews-modal-inner");
    if(modalInner){
      modalInner.scrollTop = 0;
    }

  }, 200); // важно: трябва малко delay

});
document.addEventListener("click", function(e){

  const trigger = e.target.closest(".stamped-instagram-media-block");
  if(!trigger) return;

  setTimeout(function(){

    const btns = document.querySelectorAll(".stamped-ugc-modal-tags-btn");

    btns.forEach(function(btn){

      if(btn.classList.contains("converted")) return;

      const url = btn.getAttribute("data-shoppable-url");
      if(!url) return;

      btn.classList.add("converted");

      btn.innerHTML = "";
btn.outerHTML = `
  <a href="${url}" class="stamped-buy-button stamped-shop-now">
    Shop now
  </a>
`;

    });

  }, 20); // малък delay за да се отвори modal-а

});

  let modalScrollY = 0;

function freezeBodyScroll() {
  modalScrollY = window.scrollY || window.pageYOffset || 0;

  document.body.style.position = "fixed";
  document.body.style.top = `-${modalScrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}

function unfreezeBodyScroll() {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";

  window.scrollTo(0, modalScrollY);
}

  let stampedReviewsObserver = null;
let stampedReviewsFallbackTimer = null;

function getStampedReviewCount() {
  const badge =
    document.querySelector(".stamped-product-reviews-badge") ||
    document.querySelector(".stamped-badge") ||
    document.querySelector("[data-id='stamped-badge']");

  const caption = document.querySelector(".stamped-badge-caption");

  if (!badge && !caption) {
    return null;
  }

  const raw =
    caption?.dataset?.reviews ||
    caption?.getAttribute("data-reviews") ||
    badge?.getAttribute("data-rating-count") ||
    badge?.getAttribute("data-reviews") ||
    caption?.textContent ||
    "";

  const match = String(raw).match(/\d+/);

  if (match) {
    return parseInt(match[0], 10);
  }

  return 0;
}

function applyStampedReviewsState() {
  const reviews = getStampedReviewCount();
  const panel = document.getElementById("product-reviews-panel");

  if (reviews === null) {
    return;
  }

  if (reviews > 0) {
    document.documentElement.classList.remove("no-reviews");

    if (panel) {
      const openModal = panel.dataset.openModal === "true";

      if (panel.dataset.visibleDefault === "true" && !openModal) {
        panel.style.display = "block";
      }
    }

    if (stampedReviewsObserver) {
      stampedReviewsObserver.disconnect();
      stampedReviewsObserver = null;
    }

    if (stampedReviewsFallbackTimer) {
      clearTimeout(stampedReviewsFallbackTimer);
      stampedReviewsFallbackTimer = null;
    }

    return;
  }

  document.documentElement.classList.add("no-reviews");
}

function initStampedReviewsCheck() {
  applyStampedReviewsState();

  const badge =
    document.querySelector(".stamped-badge-caption") ||
    document.querySelector(".stamped-product-reviews-badge") ||
    document.querySelector("[data-id='stamped-badge']");

  const observeTarget = badge || document.getElementById("product-reviews-panel");

  if (observeTarget) {
    stampedReviewsObserver = new MutationObserver(function () {
      applyStampedReviewsState();
    });

    stampedReviewsObserver.observe(observeTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });
  }

  let attempts = 0;

  stampedReviewsFallbackTimer = setInterval(function () {
    attempts += 1;
    applyStampedReviewsState();

    if (attempts >= 20 || !document.documentElement.classList.contains("no-reviews")) {
      clearInterval(stampedReviewsFallbackTimer);
      stampedReviewsFallbackTimer = null;

      if (stampedReviewsObserver) {
        stampedReviewsObserver.disconnect();
        stampedReviewsObserver = null;
      }
    }
  }, 500);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStampedReviewsCheck);
} else {
  initStampedReviewsCheck();
}

function openReviewsModal() {
  const modal = document.getElementById("reviews-modal");
  const modalTarget = document.getElementById("reviews-modal-target");
  const holder = document.getElementById("reviews-widget-holder");

  if (!modal || !modalTarget || !holder) return;

  modalTarget.appendChild(holder);
  modal.style.display = "block";
  document.body.classList.add("reviews-modal-open");
  freezeBodyScroll();
  if (window.StampedFn) {
    setTimeout(function () {
      StampedFn.reloadUGC();
    }, 80);
  }
}

function closeReviewsModal() {
  const modal = document.getElementById("reviews-modal");
  const originalTarget = document.getElementById("reviews-panel-target");
  const holder = document.getElementById("reviews-widget-holder");

  if (holder && originalTarget) {
    originalTarget.appendChild(holder);
  }

  if (modal) {
    modal.style.display = "none";
  }

  document.body.classList.remove("reviews-modal-open");
  unfreezeBodyScroll();
  if (window.StampedFn) {
    setTimeout(function () {
      StampedFn.reloadUGC();
    }, 80);
  }
}

function scrollToReviewsPanel() {
  const panel = document.getElementById("product-reviews-panel");
  if (!panel) return;

  if (panel.style.display === "none") {
    panel.style.display = "block";
  }

  const y = panel.getBoundingClientRect().top + window.pageYOffset - 120;

  window.scrollTo({
    top: y,
    behavior: "smooth"
  });
}

/* badge click: CAPTURE phase, за да спрем anchor scroll-а навреме */
document.addEventListener("click", function (e) {
  const badge = e.target.closest(".stamped-product-reviews-badge, .stamped-badge, .stamped-badge-caption, [data-id='stamped-badge']");
  if (!badge) return;

  const anchor = e.target.closest("a");
  if (anchor) {
    e.preventDefault();
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const panel = document.getElementById("product-reviews-panel");
  if (!panel) return;

  const openModal = panel.dataset.openModal === "true";

  if (openModal) {
    openReviewsModal();
  } else {
    scrollToReviewsPanel();
  }
}, true);

/* close button */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".reviews-modal-close");
  if (!btn) return;

  e.preventDefault();
  closeReviewsModal();
});

/* overlay close */
document.addEventListener("click", function (e) {
  const modal = document.getElementById("reviews-modal");
  if (!modal) return;
  if (modal.style.display !== "block") return;

  if (e.target === modal) {
    closeReviewsModal();
  }
});


document.addEventListener("stamped:widget:instagram-feed:loaded", function () {
  const widget = document.querySelector("#stamped-reviews-widget");
  const header = document.querySelector(".instagram-panel-header");

  if (!widget || !header) return;

  const total = parseInt(widget.dataset.total || "0", 10);

  if (total > 0) {
    header.style.display = "block";
    widget.classList.add("stamped-loaded");
  }
});

})();


/* BDK: stable mobile gesture helper for cart drawer upsell sliders - optimized */
(function () {
  if (window.__bdkCartUpsellGestureHelper) return;
  window.__bdkCartUpsellGestureHelper = true;

  var SLIDER_SELECTOR = [
    'cart-drawer .cart__widget__products:not(.mystery-cart) .grid--slider',
    'cart-drawer .cart__widget__products:not(.mystery-cart) .grid--mobile-slider'
  ].join(', ');

  var state = null;
  var rafId = 0;
  var pendingScrollLeft = 0;
  var suppressClickUntil = 0;
  var listenersAttached = false;

  function isMobileTouch() {
    return (
      window.matchMedia &&
      window.matchMedia('(max-width: 749px)').matches &&
      window.matchMedia('(pointer: coarse)').matches
    );
  }

  function getSlider(target) {
    return target && target.closest ? target.closest(SLIDER_SELECTOR) : null;
  }

  function isCartDrawerOpen(slider) {
    var drawer = slider && slider.closest('cart-drawer');

    return !!(
      drawer &&
      (
        drawer.classList.contains('is-open') ||
        drawer.hasAttribute('open') ||
        drawer.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function applyScroll() {
    rafId = 0;

    if (!state || !state.slider) return;

    state.slider.scrollLeft = pendingScrollLeft;
  }

  function scheduleScroll(left) {
    pendingScrollLeft = left;

    if (rafId) return;

    rafId = window.requestAnimationFrame(applyScroll);
  }

  function attachMoveListeners() {
    if (listenersAttached) return;

    listenersAttached = true;

    document.addEventListener('pointermove', onPointerMove, { capture: true, passive: false });
    document.addEventListener('pointerup', onPointerUp, true);
    document.addEventListener('pointercancel', onPointerCancel, true);
  }

  function detachMoveListeners() {
    if (!listenersAttached) return;

    listenersAttached = false;

    document.removeEventListener('pointermove', onPointerMove, true);
    document.removeEventListener('pointerup', onPointerUp, true);
    document.removeEventListener('pointercancel', onPointerCancel, true);
  }

  function clearState() {
    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = 0;
    }

    state = null;
    detachMoveListeners();
  }

  function onPointerMove(event) {
    if (!state || event.pointerId !== state.pointerId) return;

    var dx = event.clientX - state.startX;
    var dy = event.clientY - state.startY;
    var absX = Math.abs(dx);
    var absY = Math.abs(dy);

    if (!state.mode) {
      if (absX < 7 && absY < 7) return;

      if (absY > absX + 4) {
        clearState();
        return;
      }

      if (absX > absY + 4) {
        state.mode = 'horizontal';

        try {
          state.slider.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    if (state.mode !== 'horizontal') return;

    event.preventDefault();
    scheduleScroll(state.startScrollLeft - dx);
  }

  function onPointerUp(event) {
    if (!state || event.pointerId !== state.pointerId) return;

    if (state.mode === 'horizontal') {
      suppressClickUntil = Date.now() + 250;
    }

    clearState();
  }

  function onPointerCancel(event) {
    if (!state || event.pointerId !== state.pointerId) return;

    clearState();
  }

  document.addEventListener('pointerdown', function (event) {
    if (!isMobileTouch()) return;
    if (!event.isPrimary) return;
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;

    var slider = getSlider(event.target);
    if (!slider || !isCartDrawerOpen(slider)) return;

    state = {
      slider: slider,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startScrollLeft: slider.scrollLeft,
      mode: null
    };

    attachMoveListeners();
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    if (Date.now() > suppressClickUntil) return;

    var slider = getSlider(event.target);
    if (!slider) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);
})();

 // UPSELL TRACKING

(function () {
  window.dataLayer = window.dataLayer || [];

  var seenUpsellViews = {};
  var drawerObserver = null;
  var drawerTrackTimer = null;

  function getText(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getBlockType(widget) {
    if (!widget) return 'unknown';

    if (widget.hasAttribute('data-upsell-widget')) {
      return 'cart_related';
    }

    return 'manual_upsell';
  }

  function getWidgetDevice(widget) {
    if (widget) {
      if (widget.classList.contains('desktop')) return 'desktop';
      if (widget.classList.contains('mobile')) return 'mobile';
    }

    return window.innerWidth < 768 ? 'mobile' : 'desktop';
  }

  function getCartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function isCartDrawerOpen(cartDrawer) {
    return !!(cartDrawer && cartDrawer.classList.contains('is-open'));
  }

  function getProductData(productHolder, widget) {
    if (!productHolder || !widget) return null;

    var titleEl = widget.querySelector('.cart__widget__title');
    var blockName = getText(titleEl);

    var nameEl = productHolder.querySelector('.product-upsell__title');
    var productName = getText(nameEl);

    var linkEl =
      productHolder.querySelector('.product-upsell__image a') ||
      productHolder.querySelector('.product-upsell__content > a');

    var productUrl = linkEl ? linkEl.getAttribute('href') || '' : '';

    var productId =
      productHolder.getAttribute('data-quick-add-holder') ||
      (productHolder.querySelector('input[name="product-id"]') || {}).value ||
      '';

    var variantId =
      (productHolder.querySelector('input[name="id"]') || {}).value ||
      '';

    return {
      product_name: productName,
      product_url: productUrl,
      product_id: productId ? String(productId) : '',
      variant_id: variantId ? String(variantId) : '',
      block_name: blockName,
      block_type: getBlockType(widget),
      widget_device: getWidgetDevice(widget)
    };
  }

  function buildViewKey(data) {
    return [
      data.product_id || '',
      data.block_name || '',
      data.widget_device || ''
    ].join('|');
  }

  function trackUpsellViews() {
    var cartDrawer = getCartDrawer();
    if (!isCartDrawerOpen(cartDrawer)) return;

    var productHolders = cartDrawer.querySelectorAll('.product-upsell__holder--cart');

    productHolders.forEach(function (productHolder) {
      var widget = productHolder.closest('details.cart__widget');
      if (!widget || !cartDrawer.contains(widget)) return;

      var data = getProductData(productHolder, widget);
      if (!data || !data.product_id) return;

      var viewKey = buildViewKey(data);
      if (seenUpsellViews[viewKey]) return;

      seenUpsellViews[viewKey] = true;

      window.dataLayer.push({
        event: 'cart_upsell_view',
        upsell_product_name: data.product_name,
        upsell_product_url: data.product_url,
        upsell_product_id: data.product_id,
        upsell_variant_id: data.variant_id,
        upsell_block_name: data.block_name,
        upsell_block_type: data.block_type,
        upsell_widget_device: data.widget_device
      });
    });
  }

  function resetSeenViewsIfDrawerClosed() {
    var cartDrawer = getCartDrawer();

    if (!isCartDrawerOpen(cartDrawer)) {
      seenUpsellViews = {};
    }
  }

  function scheduleTrackUpsellViews() {
    if (drawerTrackTimer) {
      clearTimeout(drawerTrackTimer);
    }

    drawerTrackTimer = setTimeout(function () {
      resetSeenViewsIfDrawerClosed();
      trackUpsellViews();
    }, 120);
  }

  document.addEventListener('click', function (event) {
    var cartDrawer = event.target.closest('#cart-drawer');
    if (!cartDrawer || !isCartDrawerOpen(cartDrawer)) return;

    var addButton = event.target.closest('.product-upsell__btn');
    var productLink = event.target.closest('.product-upsell__image a, .product-upsell__content > a');

    if (!addButton && !productLink) return;

    var productHolder = event.target.closest('.product-upsell__holder--cart');
    if (!productHolder || !cartDrawer.contains(productHolder)) return;

    var widget = event.target.closest('details.cart__widget');
    if (!widget || !cartDrawer.contains(widget)) return;

    var data = getProductData(productHolder, widget);
    if (!data) return;

    var clickType = addButton ? 'add_button' : 'product_link';

    var addMode = '';
    if (addButton) {
      if (addButton.hasAttribute('data-add-to-cart')) {
        addMode = 'direct_add';
      } else if (addButton.hasAttribute('data-quick-add-modal-handle')) {
        addMode = 'quick_add_modal';
      } else {
        addMode = 'unknown';
      }
    }

    window.dataLayer.push({
      event: 'cart_upsell_click',
      upsell_product_name: data.product_name,
      upsell_product_url: data.product_url,
      upsell_product_id: data.product_id,
      upsell_variant_id: data.variant_id,
      upsell_block_name: data.block_name,
      upsell_block_type: data.block_type,
      upsell_click_type: clickType,
      upsell_add_mode: addMode,
      upsell_widget_device: data.widget_device
    });
  }, true);

  function attachDrawerObserver() {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || drawerObserver) return;

    drawerObserver = new MutationObserver(function () {
      scheduleTrackUpsellViews();
    });

    drawerObserver.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });

    scheduleTrackUpsellViews();
  }

  function initUpsellTracking() {
    attachDrawerObserver();

    var initObserver = new MutationObserver(function () {
      if (!drawerObserver && getCartDrawer()) {
        attachDrawerObserver();
      }
    });

    initObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      initObserver.disconnect();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellTracking);
  } else {
    initUpsellTracking();
  }
})();

(function () {

  // TAPCART MOBILE LINKS MODIFY
  document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('tapcart-webview')) return;

  const links = document.querySelectorAll('main a[href]');

  links.forEach(link => {
    const href = link.getAttribute('href');
    if (!href) return;

    // skip anchors / special links
    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return;
    }

    let url;

    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    // only internal links
    if (url.origin !== window.location.origin) return;

    // skip product pages
    if (url.pathname.startsWith('/products/')) return;

    // skip if already mobile
    if (url.pathname.endsWith('/mobile')) return;

    // skip files/assets if needed
    if (/\.(jpg|jpeg|png|webp|gif|svg|pdf|zip)$/i.test(url.pathname)) return;

    // add /mobile before query/hash
    url.pathname = url.pathname.replace(/\/$/, '') + '/mobile';

    link.setAttribute('href', url.pathname + url.search + url.hash);
  });
});


  document.addEventListener('click', function (e) {

  const path = e.composedPath(); // важно за shadow DOM

  let rewardsLauncher = null;
  let learnMoreBtn = null;

  path.forEach(function (el) {

    /* ===== FOOTER / LAUNCHER ===== */
    if (
      el.classList &&
      el.classList.contains('gw-rd-popup-widget-launcher-btn')
    ) {
      rewardsLauncher = el;
    }

    /* ===== PDP / LEARN MORE ===== */
    if (
      el.classList &&
      el.classList.contains('gw-btn') &&
      el.innerText &&
      el.innerText.trim().toLowerCase().includes('learn more')
    ) {
      learnMoreBtn = el;
    }

  });



  
  /* ============================= */
  /* ===== FOOTER REWARDS ======== */
  /* ============================= */
  if (rewardsLauncher) {

    let textEl = rewardsLauncher.querySelector('.gw-layout-text');
    let buttonText = textEl ? textEl.innerText.trim() : 'Rewards';
    let rewardsPosition = rewardsLauncher.getAttribute('data-bdk-rewards-position') || 'footer';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'rewards_clicks',
      rewards_text: buttonText,
      rewards_position: rewardsPosition,
      rewards_device: window.innerWidth < 768 ? 'mobile' : 'desktop'
    });

    return;
  }

  /* ============================= */
  /* ===== PDP LEARN MORE ========= */
  /* ============================= */
  if (learnMoreBtn) {

    let buttonText = learnMoreBtn.innerText.trim();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'rewards_clicks',
      rewards_text: buttonText,
      rewards_position: 'product_page',
      rewards_device: window.innerWidth < 768 ? 'mobile' : 'desktop'
    });

    return;
  }

});


  



 document.addEventListener("DOMContentLoaded", function () {

  const blocks = document.querySelectorAll(
    ".bogo-cart-wrapper .free-shipping-message, .bogo-content_wrapper .free-shipping-message"
  );

  blocks.forEach(block => {
    const baseEl   = block.querySelector(".fs-base");
    const amountEl = block.querySelector(".fs-amount");
    const symbolEl = block.querySelector(".fs-symbol");
    const codeEl   = block.querySelector(".fs-code");

    if (!baseEl || !amountEl || !symbolEl || !codeEl) return;

    const base   = parseFloat(baseEl.dataset.base);
    const symbol = symbolEl.dataset.symbol;
    const code   = codeEl.dataset.code;

    const rate = window.Shopify?.currency?.rate || 1;

    let converted = base * rate;
    let final;

    if (code === "USD") {
      final = Math.floor(converted);
    } else {
      final = Math.ceil(converted / 5) * 5;
    }

    if (code === "USD") {
      amountEl.innerText = symbol + final;
    } else if (code === "AUD") {
      amountEl.innerText = symbol + final + " " + code;
    } else if (code === "CAD") {
      amountEl.innerText = symbol + final + " " + code;
    } else {
      amountEl.innerText = symbol + final;
    }
  });
});


   // -----------------------------------------------------------
//  FILTER ACCORDION INIT FUNCTION (runs also after AJAX reload)
// -----------------------------------------------------------
function initColorNames() {

  document.querySelectorAll('.pt-display-swatch .pt-filter-link').forEach(link => {
    const icon = link.querySelector('i');
    if (icon) {
      link.innerHTML = '';
      link.appendChild(icon);
    }
  });
  
  document.querySelectorAll('.filter-group-color .collection-container')
    .forEach(item => {

      

      const nameBox = item.querySelector('.collection-name');
      if (!nameBox) return;

      const link = item.querySelector('.pt-filter-link');
      if (!link) return;

      let title = link.getAttribute('title') || "";
      let colorName = title
        .replace("Add Filter: ", "")
        .replace("Clear Filter: ", "")
        .trim();

      nameBox.querySelectorAll('span').forEach(s => s.remove());

      const span = document.createElement('span');
      span.textContent = colorName;
      span.style.cssText = `
        color: #000;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 9px;
        padding-left: 2px;
        text-transform: capitalize;
      `;

      nameBox.appendChild(span);
    });
}

function initAccordions() {
  // BADINKA: Power Tools' native pt-group-expanded state is the only
  // accordion state manager. Remove any stale class left by the retired
  // custom accordion implementation without binding a second click handler.
  document.querySelectorAll('.filter-menu .filter-group.is-open').forEach(group => {
    group.classList.remove('is-open');
  });
}


document.addEventListener('ptOnLoad', () => {
    initAccordions();
    initColorNames();
});


// -----------------------------------------------------------
// INITIAL DOMContentLoaded
// -----------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
/*
  // Desktop close button logic
  const filterTriggerBtn = document.querySelector('#pt-filter-drawer-btn');
  const filterDrawer = document.querySelector('#filter-groups');
  const mobileCloseBtn = document.querySelector('[data-collection-sidebar-close]');
  const existingDesktopClose = document.querySelector('.bdk-desktop-close');

  if (filterTriggerBtn && filterDrawer) {

    if (existingDesktopClose) existingDesktopClose.remove();

    const desktopCloseBtn = document.createElement('a');
    desktopCloseBtn.className = 'collection__sidebar__close bdk-desktop-close';
    desktopCloseBtn.setAttribute('href', '#filters-group');
    desktopCloseBtn.setAttribute('aria-label', 'Hide Filters');
    desktopCloseBtn.innerHTML = `
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel" viewBox="0 0 24 24">
        <path d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    const markerNode = document.querySelector('.pt-filter-drawer-close-btn');

    if (markerNode) {
      markerNode.insertAdjacentElement('afterend', desktopCloseBtn);
    } else {
      filterTriggerBtn.insertAdjacentElement('afterend', desktopCloseBtn);
    }

    desktopCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      mobileCloseBtn?.click();
    });
  }

  // Sort → auto-close filters fix
  document.addEventListener('click', function (e) {
    const sortBtn = e.target.closest('.popout--sort .popout__toggle');
    const filterDrawer = document.querySelector('#filter-groups');
    const filterBtn = document.querySelector('.popout__toggle--filters');

    if (!sortBtn) return;

    if (filterDrawer && filterDrawer.classList.contains('expanded')) {
      filterBtn?.click();

      setTimeout(() => {
        sortBtn.click();
      }, 250);

      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Swatch icon cleanup
  
*/
  // INIT accordion FIRST TIME
  initAccordions();
  initColorNames();
});


// -----------------------------------------------------------
// RE-INIT accordion AFTER AJAX FILTER REFRESH
// -----------------------------------------------------------

const hasCartDrawer = document.querySelector('[data-cart-drawer]') || document.querySelector('#cart-drawer');

if (hasCartDrawer) {
  let upsellReloadTimer = null;
  let upsellReloadInProgress = false;
  let lastUpsellContent = '';

  function getCartDrawerEl() {
    return document.querySelector('[data-cart-drawer]') || document.querySelector('#cart-drawer');
  }

  function cartDrawerIsOpen() {
    const drawer = getCartDrawerEl();
    return !!(
      drawer &&
      (
        drawer.classList.contains('is-open') ||
        drawer.hasAttribute('open') ||
        drawer.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function reloadCartUpsells() {
    const drawer = getCartDrawerEl();
    if (!drawer) return;

    const containers = document.querySelectorAll('[data-upsell-products]');
    if (!containers.length) return;

    if (upsellReloadInProgress) return;
    upsellReloadInProgress = true;

    fetch(`${window.Shopify.routes.root}?sections=api-cart-items`, {
      credentials: 'same-origin'
    })
      .then(res => res.json())
      .then(data => {
        const html = data['api-cart-items'];
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newUpsells = doc.querySelector('[data-api-upsell-items]');
        const newContent = newUpsells ? newUpsells.innerHTML.trim() : '';

        if (!newContent) return;

        if (newContent === lastUpsellContent) return;
        lastUpsellContent = newContent;

        let changed = false;

        containers.forEach(container => {
          if (container.closest('[data-bestseller-upsell]')) return;

          if (container.innerHTML.trim() !== newContent) {
            container.innerHTML = newContent;
            changed = true;
          }
        });

        if (!changed) return;

        document.dispatchEvent(new CustomEvent('theme:cart:init'));
      })
      .catch(err => console.error('❌ Error fetching upsells', err))
      .finally(() => {
        upsellReloadInProgress = false;
      });
  }

  document.addEventListener('theme:cart:change', function () {
    if (upsellReloadTimer) {
      clearTimeout(upsellReloadTimer);
    }

    upsellReloadTimer = setTimeout(function () {
      if (!cartDrawerIsOpen()) return;

      reloadCartUpsells();
    }, 900);
  });
}


function initRandomBestsellers() {
  document.querySelectorAll('[data-random-bestsellers]').forEach(function (container) {
    if (container.dataset.randomized === 'true') return;

    const visibleCount = parseInt(container.dataset.visibleCount || '6', 10);
    const items = Array.from(container.children).filter(function (item) {
      return item.classList.contains('grid-item');
    });

    if (!items.length) return;

    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.slice(visibleCount).forEach(item => item.remove());

    const fragment = document.createDocumentFragment();
    items.slice(0, visibleCount).forEach(item => fragment.appendChild(item));
    container.appendChild(fragment);

    container.dataset.randomized = 'true';

    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  });
}

document.addEventListener('DOMContentLoaded', initRandomBestsellers);
document.addEventListener('theme:cart:init', initRandomBestsellers);
document.addEventListener('theme:section:load', initRandomBestsellers);

document.addEventListener('theme:cart:change', function () {
  setTimeout(function () {
    document.querySelectorAll('[data-random-bestsellers]').forEach(function (container) {
      delete container.dataset.randomized;
    });

    initRandomBestsellers();
  }, 950);
});

  const wrap = document.querySelector('.product__price__wrap');
  if (!wrap) return;

  if (!wrap.querySelector('.bogoprice') && !document.querySelector('.product__price__wrap .bogoprice, .bogo-text .bogoprice')) {
  return;
  }

  // търси текущите елементи всеки път (Shopify ги подменя)
  function getPriceNode() {
    return wrap.querySelector('.product__price [data-product-price]') ||
           wrap.querySelector('.product__price .money') ||
           wrap.querySelector('.product__price') ||
           null;
  }
  function getBogoEl() {
    // първо в wrap…
    return wrap.querySelector('.bogoprice') ||
           // …ако при теб bogoprice не е вътре, пробвай глобално:
           document.querySelector('.product__price__wrap .bogoprice, .bogo-text .bogoprice');
  }

  function parsePrice(text) {
    if (!text) return null;
    // махни конвертирани стойности в скоби
    text = text.replace(/\([^)]*\)/g, '').trim();

    const match = text.match(/([0-9]+(?:[.,][0-9]{3})*(?:[.,][0-9]{1,2})?)/);
    if (!match) return null;

    let num = match[1];
    if (num.includes('.') && num.includes(',')) num = num.replace(/,/g, '');
    else if (num.includes(',') && !num.includes('.')) num = num.replace(',', '.');

    const value = parseFloat(num);
    if (isNaN(value)) return null;

    const before = text.slice(0, match.index).trim();
    const after  = text.slice(match.index + match[1].length).trim();

    let prefix = '';
    let suffix = '';
    const beforeSym = before.match(/([$€£])$/);
    if (beforeSym) prefix = beforeSym[1];
    const afterTok = after.match(/^([^\d\s.,]+)/);
    if (afterTok) suffix = afterTok[1];

    return { value, prefix, suffix };
  }

  function computeDiscounted(value, discountPct) {
    const baseCents = Math.round(value * 100);
    const factor = 100 - discountPct;
    const discountedCents = Math.ceil((baseCents * factor) / 100); // ceil до 0.01
    return (discountedCents / 100).toFixed(2);
  }

  function updateBogoprice() {
    const priceNode = getPriceNode();
    const bogoEl = getBogoEl();
    if (!priceNode || !bogoEl) return;

    const discount = parseFloat(bogoEl.getAttribute('data-discount')) || 70;
    const raw = priceNode.textContent.trim();
    const parsed = parsePrice(raw);
    if (!parsed) return;

    const discounted = computeDiscounted(parsed.value, discount);
    bogoEl.textContent = `${parsed.prefix}${discounted}${parsed.suffix ? ' ' + parsed.suffix : ''}`;
  }

  // дебаунс, защото Shopify прави много малки DOM промени
  let rafId = null;
  const scheduleUpdate = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateBogoprice();
    });
  };

  // първоначално
  scheduleUpdate();

  // наблюдавай целия wrap, защото .product__price често се подменя
  const mo = new MutationObserver(scheduleUpdate);
  mo.observe(wrap, { childList: true, subtree: true, characterData: true });

  // fallback при смяна на вариант (селект/радио)
  document.addEventListener('change', (e) => {
    if (wrap.contains(e.target) && (e.target.matches('select, input[name="id"], input[type="radio"]'))) {
      scheduleUpdate();
    }
  });

  // fallback при history навигация / динамични ре-рендъри
  window.addEventListener('popstate', scheduleUpdate);
  window.addEventListener('pageshow', scheduleUpdate);
})();



(function initCartRecommendationBehavior(){
  var ROOT_SEL = 'cart-drawer [data-bdk-recommendation-mode]';
  var MYSTERY_SEL = '[data-bdk-recommendation="mystery"]';
  var COMPLETE_SEL = '[data-bdk-recommendation="complete-look"]';
  var HOT_SEL = '[data-bdk-recommendation="hot-right-now"]';
  var MYSTERY_STATE_SEL = '[data-items-holder] [data-bdk-cart-mystery-state]';
  var COMPLETE_STATE_SEL = '[data-items-holder] [data-bdk-complete-look-state]';
  var lastSmartState = new WeakMap();

  function markerIsTrue(root, selector, attributeName) {
    var marker = root.querySelector(selector);
    return !!marker && marker.getAttribute(attributeName) === 'true';
  }

  function cartHasMystery(root) {
    return markerIsTrue(root, MYSTERY_STATE_SEL, 'data-bdk-cart-mystery-state');
  }

  function completeLookHasProducts(root) {
    return markerIsTrue(root, COMPLETE_STATE_SEL, 'data-bdk-complete-look-state');
  }

  function hotRightNowHasProducts(root) {
    return !!root.querySelector(HOT_SEL + '[data-bdk-has-products="true"]');
  }

  function setPanelOpen(panel, shouldOpen) {
    if (!panel) return;

    var body = panel.querySelector('[data-collapsible-body]');

    if (shouldOpen) {
      panel.setAttribute('open', 'true');
      if (body) body.style.height = 'auto';
      return;
    }

    panel.removeAttribute('open');
    if (body) body.style.height = '';
  }

  function syncMysteryVisibility(root) {
    var shouldHide = cartHasMystery(root);

    root.querySelectorAll('[data-bdk-mystery-curated]').forEach(function (panel) {
      panel.hidden = shouldHide;
      panel.style.display = shouldHide ? 'none' : '';
    });
  }

  function smartStateKey(root) {
    return [
      cartHasMystery(root) ? '1' : '0',
      root.querySelector(MYSTERY_SEL) ? '1' : '0',
      completeLookHasProducts(root) ? '1' : '0',
      hotRightNowHasProducts(root) ? '1' : '0'
    ].join(':');
  }

  function applySmartPriority(root, force) {
    if (root.getAttribute('data-bdk-recommendation-mode') !== 'smart') return;

    var key = smartStateKey(root);
    if (!force && lastSmartState.get(root) === key) return;
    lastSmartState.set(root, key);

    var mysteryPanels = Array.from(root.querySelectorAll(MYSTERY_SEL)).filter(function (panel) {
      return !panel.hidden;
    });
    var completePanels = Array.from(root.querySelectorAll(COMPLETE_SEL));
    var hotPanels = Array.from(root.querySelectorAll(HOT_SEL));
    var target = '';

    if (mysteryPanels.length && !cartHasMystery(root)) {
      target = 'mystery';
    } else if (completePanels.length && completeLookHasProducts(root)) {
      target = 'complete-look';
    } else if (hotPanels.length && hotRightNowHasProducts(root)) {
      target = 'hot-right-now';
    }

    root.querySelectorAll(MYSTERY_SEL + ', ' + COMPLETE_SEL + ', ' + HOT_SEL).forEach(function (panel) {
      setPanelOpen(panel, panel.getAttribute('data-bdk-recommendation') === target && !panel.hidden);
    });
  }

  function syncRoot(root, forceSmart) {
    syncMysteryVisibility(root);
    applySmartPriority(root, !!forceSmart);
  }

  function syncAll(forceSmart) {
    document.querySelectorAll(ROOT_SEL).forEach(function (root) {
      syncRoot(root, forceSmart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll(true);
    }, { once: true });
  } else {
    syncAll(true);
  }

  // Broadcast has already refreshed the server-rendered cart state markers
  // when these events fire. No extra request, polling, or observer is needed.
  document.addEventListener('theme:cart:change', function () {
    syncAll(false);
  });

  document.addEventListener('theme:cart:init', function () {
    syncAll(false);
  });

  // Smart mode behaves as a default-open policy per drawer session. Reopening
  // the drawer reapplies the priority; manual user toggles are otherwise left alone.
  document.addEventListener('theme:cart-drawer:open', function () {
    syncAll(true);
  });

  document.addEventListener('shopify:section:load', function () {
    syncAll(true);
  });
})();


/* BDK Mystery: use the shared explicit variant-selection lifecycle.
   Do not auto-select Gender or Size in cart quick-add/modal contexts. */


/*
(function () {
  const PRODUCT_HANDLE = 'mystery-halloween-costume';

  // Проверява дали този контейнер е за конкретния продукт (по линк към handle)
  function containerBelongsToTarget(container) {
    // ако сме на самата продуктова страница, също разрешаваме
    if (location.pathname.includes(`/products/${PRODUCT_HANDLE}`)) return true;

    // търсим линк към продукта в най-близкия попъп/форм-обвивка
    const root =
      container.closest('[data-form-wrapper]') ||
      container.closest('.product-quick-add__form') ||
      container.closest('.drawer, .modal, .product__form__outer, .product__block') ||
      document;

    return !!root.querySelector(`a[href*="/products/${PRODUCT_HANDLE}"]`);
  }

  function wireSelectors(root) {
    const container = root.matches?.('.product__selectors,[data-product-variants]')
      ? root
      : root.querySelector?.('.product__selectors,[data-product-variants]');
    if (!container || container.__wired) return;
    if (!containerBelongsToTarget(container)) return; // новият гейт по handle
    container.__wired = true;

    // покажи size блока ако е скрит
    container.querySelectorAll('.selector-wrapper.selector-wrapper--size, .product__selectors [data-option-position="2"]')
      .forEach(el => el.style.display = 'block');

    // локални селектори
    const genderRadios = Array.from(container.querySelectorAll('input[name^="options[Gender]"]'));
    const sizeRadios   = Array.from(container.querySelectorAll('input[name^="options[Size]"]'));
    if (!genderRadios.length || !sizeRadios.length) return;

    const manRadio   = genderRadios.find(r => (r.value || '').toLowerCase() === 'man');
    const womanRadio = genderRadios.find(r => (r.value || '').toLowerCase() === 'woman');

    // Разреши MAN да е кликаем
    if (manRadio) {
      manRadio.classList.remove('sold-out');
      manRadio.removeAttribute('disabled');
      const manWrap = manRadio.closest('.radio__button, .selector-wrapper, span');
      if (manWrap) manWrap.classList.remove('sold-out');
    }

    function selectSizeWithFallback(preferredList = []) {
      let target = null;
      for (const val of preferredList) {
        const c = sizeRadios.find(r => (r.value || '').toLowerCase() === val.toLowerCase());
        if (c && !c.disabled && !c.classList.contains('sold-out')) { target = c; break; }
      }
      if (!target) target = sizeRadios.find(r => !r.disabled && !r.classList.contains('sold-out')) || sizeRadios[0];
      if (target) {
        if (!target.checked) target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function onGenderChange(e) {
      const val = (e.target.value || '').toLowerCase();
      if (val === 'man') {
        selectSizeWithFallback(['S-M', 'L-XL']);
      } else if (val === 'woman') {
        selectSizeWithFallback(['XS', 'S', 'M', 'L', 'XL', 'XXL']);
      }
    }

    genderRadios.forEach(r => {
      r.classList.remove('sold-out');
      r.removeAttribute('disabled');
      const wrap = r.closest('.radio__button, .selector-wrapper, span');
      if (wrap) wrap.classList.remove('sold-out');

      r.removeEventListener('change', onGenderChange);
      r.addEventListener('change', onGenderChange);
    });

    // Инициализация при поява
    const checked = genderRadios.find(r => r.checked);
    if (checked) {
      checked.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (womanRadio) {
      womanRadio.checked = true;
      womanRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // за вече наличните контейнери
    document.querySelectorAll('.product__selectors,[data-product-variants]').forEach(wireSelectors);

    // за динамично инжектираните (попъпи)
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches('.product__form__outer,.product__selectors,[data-product-variants]')) {
            wireSelectors(node);
          } else {
            const found = node.querySelector?.('.product__form__outer,.product__selectors,[data-product-variants]');
            if (found) wireSelectors(found);
          }
        });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
*/

(function() {


  
   // Увери се, че браузърът има право да възстановява скрола
  if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

  // 1) Преди да напуснеш списъка, запиши #<id> на кликнатия продукт в URL-а
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a.product-link[id]');
    if (!link) return;

    // Ако отваряш в нов таб/прозорец, не пипай текущия URL
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

    const id = link.id; // напр. "pr9646213005652"
    // Добавяме хеша без да пречим на навигацията към продукта
    try {
      history.replaceState(history.state, '', location.pathname + location.search + '#' + encodeURIComponent(id));
    } catch (_) {
      // fallback
      location.hash = id;
    }
    // не викай preventDefault – остави линка да навигира
  });

  // 2) При връщане назад – ако има hash, подсети браузъра да скролира до елемента
  window.addEventListener('pageshow', function () {
    if (!location.hash) return;
    const el = document.querySelector(location.hash);
    if (!el) return;
    // изчакай един кадър, за да се стабилизира layout-ът
    requestAnimationFrame(() => {
      // ако имаш лепкав header, CSS по-долу ще се погрижи за отстъпа
     // el.scrollIntoView({ block: 'start', inline: 'nearest' });
    });
  });
  

 document.addEventListener("DOMContentLoaded", function () {

   
    const path = window.location.pathname;

    const isProduct = /^\/products\/.+/.test(path);
    const isCollection = /^\/collections\/[^\/]+(\/.*)?$/.test(path);

    const hasCollectionData = localStorage.getItem("lastCollectionLink") || localStorage.getItem("lastCollectionName");

    if (!isProduct && !isCollection && hasCollectionData) {
      localStorage.removeItem("lastCollectionLink");
      localStorage.removeItem("lastCollectionName");
    }
  });
  
// redirect product urls with included collection to clean url without collection
const currentUrl = window.location.href;
const pattern = /\/collections\/[^\/]+\/products\/(.+)/;

const match = currentUrl.match(pattern);
if (match) {
  const newUrl = `${window.location.origin}/products/${match[1]}`;
  //window.location.replace(newUrl);
}
  
  // redirect ending with / to non /
   if (
  window.location.pathname.length > 1 && 
  window.location.pathname.endsWith('/')
) {
  const newUrl =
    window.location.origin + window.location.pathname.slice(0, -1) + window.location.search + window.location.hash;
  window.location.replace(newUrl); 
}
  
const closeCartBtn = document.getElementById("close-cart-b");

if (closeCartBtn) {
  closeCartBtn.addEventListener("click", function(e){
    e.stopPropagation();

    const drawerClose = document.querySelector('.cart-block .drawer__close');
    if (drawerClose) {
      drawerClose.click();
    }
  });
}
  
  function tooltip(text,element) {
    var offsetDistance = 20;
    tt = document.getElementById('ttdiv');
	elem = document.getElementById(element.id);
	tt.style.top = elem.offsetTop + offsetDistance + 'px';
	tt.style.left = elem.offsetLeft + offsetDistance + 'px';
	tt.style.display = 'block';
	tt.innerHTML = text;
	
  }
  
  function hide() {
    tt = document.getElementById('ttdiv');
	tt.style.display = 'none';
  }


  
window.addEventListener('DOMContentLoaded', () => {


// auto select variant with sale enabled
  /*
   var radioButton = document.querySelector('.radio__button.sale');
   var label = radioButton.querySelector('label');
   var radioButtonTest = document.querySelector('.set-options-wrapper .radio__button.sale')
   var labelTest = radioButtonTest.querySelector('label');

    if (radioButton) {
        var urlParams = new URLSearchParams(window.location.search);
        var hasVariantParam = urlParams.has('variant');
        if (!hasVariantParam) {
            if (label) {
                try {
                  function isMobile() {
                    return window.innerWidth <= 768;
                }
                function disableScroll() {
                    
                        document.body.style.overflow = 'hidden';
                        document.documentElement.style.overflow = 'hidden';
                    
                }

               
                function enableScroll() {
                 
                        document.body.style.overflow = '';
                        document.documentElement.style.overflow = '';
                 
                }
                if (isMobile()) {
                disableScroll();
                }
                var mouseEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                // setTimeout(() => {
                //   if(typeof set_test !== 'undefined' && set_test == true){
                //     labelTest ? labelTest.dispatchEvent(mouseEvent) : label.dispatchEvent(mouseEvent);
                //   }
                //   else{
                //     label.dispatchEvent(mouseEvent)
                //   }
                // },1000)
                 if (isMobile()) {
                setTimeout(enableScroll, 100);
                 }
                } catch (error) {
                }
            } else {
              

            }
        } else {
        }
    } else {
    }
  */
  const selectors = [
    'a[href="/account/logout"]',              
    'a[href^="/cart"]',              
    'a[href^="/checkout"]',          
    'a[href^="/account/login"]',     
    'a[href^="/account/register"]',     
    'a[href^="/account/recover"]',     
    'a[href^="http"]'
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(link => {
      link.setAttribute('data-no-instant', '');
    });
  });


    const videoMobile = document.getElementById("shopify-section-template--25531832631636__section_video_D7NAqn");
    const videoDesktop = document.getElementById("shopify-section-template--25531832631636__section_video_mHzX94");
    const videoMobile2 = document.getElementById("shopify-section-template--25531832631636__section_video_Pp4iHM");
    const videoDesktop2 = document.getElementById("shopify-section-template--25531832631636__section_video_UYwfjJ");
    const deferredPoster = document.querySelector('.deferred-media__poster');

if (deferredPoster && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        deferredPoster.click();
        io.disconnect(); // 1 път и край
        break;
      }
    }
  }, { root: null, threshold: 0.25 }); // 25% видимост

  io.observe(deferredPoster);
}
    
    

    document.addEventListener('click', (event) => {
    const item = event.target.closest(
        '.page_bottom_info_faq .metafield-rich_text_field h3'
    );

    if (!item) return;

    const faqContainer = item.closest('.metafield-rich_text_field');
    const answer = item.nextElementSibling;

    if (answer && answer.tagName.toLowerCase() === 'p') {
        answer.classList.toggle('show');
    }

    faqContainer.querySelectorAll('p.show').forEach((paragraph) => {
        if (paragraph !== answer) {
            paragraph.classList.remove('show');
        }
    });
});

   
    function elementIsVisibleInViewport(el, partiallyVisible = false) {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;

        const verticallyVisible = partiallyVisible
            ? rect.top < windowHeight && rect.bottom > 0
            : rect.top >= 0 && rect.bottom <= windowHeight;

        const horizontallyVisible = partiallyVisible
            ? rect.left < windowWidth && rect.right > 0
            : rect.left >= 0 && rect.right <= windowWidth;

        return verticallyVisible && horizontallyVisible;
    }
});

})();



/* BDK: require explicit product variant choice before add to cart */
(function () {
  function closestScope(el) {
    return el && (
      el.closest('[data-section-type="product"]') ||
      el.closest('[data-quick-add-modal]') ||
      el.closest('product-form') ||
      document
    );
  }

  function optionWrappers(scope) {
    return Array.from(scope.querySelectorAll('[data-product-variants] [data-option-position]'));
  }

  function hasSelection(wrapper) {
    var checkedRadio = wrapper.querySelector('input[name^="options"][type="radio"]:checked');
    if (checkedRadio && checkedRadio.value) return true;

    var hiddenInput = wrapper.querySelector('input[name^="options"][type="hidden"]');
    if (hiddenInput && hiddenInput.value) return true;

    var select = wrapper.querySelector('select[name^="options"]');
    if (select && select.value) return true;

    return false;
  }

  function optionName(wrapper) {
    return (
      wrapper.getAttribute('data-cc-option-label') ||
      wrapper.getAttribute('data-cc-option-name') ||
      wrapper.querySelector('.radio__legend__option-name')?.textContent ||
      'option'
    ).trim();
  }

  function errorMessage(wrapper) {
    var template = wrapper.getAttribute('data-cc-error-message');
    if (template) return template;
    return 'Please choose ' + optionName(wrapper) + '.';
  }

  function getMissing(scope) {
    return optionWrappers(scope).filter(function (wrapper) {
      return !hasSelection(wrapper);
    });
  }

  function setFieldState(wrapper, missing) {
    var error = wrapper.querySelector('[data-cc-field-error]');
    wrapper.classList.toggle('cc-variant-missing', missing);

    if (error) {
      if (missing) {
        error.textContent = errorMessage(wrapper);
        error.hidden = false;
      } else {
        error.textContent = '';
        error.hidden = true;
      }
    }
  }

  function syncBlankVariantState(scope) {
    var variants = scope.querySelector('[data-product-variants]');
    if (!variants) return;

    var wrappers = optionWrappers(scope);
    var hasAnySelection = wrappers.some(function (wrapper) {
      return hasSelection(wrapper);
    });

    variants.classList.toggle('bdk-no-initial-selection', !hasAnySelection);
  }

  function hideMessageIfReady(scope) {
    syncBlankVariantState(scope);

    var missing = getMissing(scope);
    optionWrappers(scope).forEach(function (wrapper) {
      setFieldState(wrapper, missing.indexOf(wrapper) !== -1);
    });
  }

  function validateBeforeAdd(button) {
    var scope = closestScope(button);
    if (!scope) return true;

    var idInput = scope.querySelector('input[name="id"][data-cc-requires-variant-selection]');
    if (!idInput) return true;

    var wrappers = optionWrappers(scope);
    var missing = getMissing(scope);

    if (!missing.length) return true;

    wrappers.forEach(function (wrapper) {
      setFieldState(wrapper, missing.indexOf(wrapper) !== -1);
    });

    missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  function initBlankVariantStates() {
    document.querySelectorAll('[data-product-variants]').forEach(function (variants) {
      syncBlankVariantState(closestScope(variants));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlankVariantStates);
  } else {
    initBlankVariantStates();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-to-cart]');
    if (!button) return;

    if (!validateBeforeAdd(button)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[name^="options"], select[name^="options"]')) return;

    var scope = closestScope(event.target);
    if (!scope) return;

    window.setTimeout(function () {
      hideMessageIfReady(scope);
    }, 0);
  }, true);
})();


/* BDK Mystery: allow Gender switching after a gender-specific Size choice.
   Reset Size first, then let the shared variant manager recalculate availability.
   No replacement Size is auto-selected. */
(function () {
  var PRODUCT_HANDLE = 'mystery-halloween-costume';

  function closestScope(el) {
    return el && (
      el.closest('[data-product-handle]') ||
      el.closest('[data-section-type="product"]') ||
      el.closest('[data-quick-add-modal]') ||
      el.closest('product-form')
    );
  }

  function isMysteryScope(scope) {
    if (!scope) return false;

    if (scope.getAttribute && scope.getAttribute('data-product-handle') === PRODUCT_HANDLE) {
      return true;
    }

    return !!scope.querySelector(
      '[data-product-handle="' + PRODUCT_HANDLE + '"], a[href*="/products/' + PRODUCT_HANDLE + '"]'
    );
  }

  function isGenderInput(input) {
    if (!input || input.type !== 'radio') return false;

    var wrapper = input.closest('[data-option-position]');
    return !!wrapper && wrapper.getAttribute('data-option-position') === '1';
  }

  function normalizeGenderAvailability(scope) {
    if (!isMysteryScope(scope)) return;

    var variants = scope.querySelector('[data-product-variants]');
    if (!variants) return;

    var genderWrapper = variants.querySelector('[data-option-position="1"]');
    if (!genderWrapper) return;

    genderWrapper.querySelectorAll('input[type="radio"]').forEach(function (input) {
      // For Mystery, Gender must always remain switchable. A sold-out/unavailable
      // class here can be caused only by the currently selected Size combination;
      // real Size availability remains untouched in option position 2.
      input.classList.remove('sold-out', 'unavailable');
      input.removeAttribute('disabled');
    });
  }

  function resetSizeBeforeGenderSwitch(genderInput) {
    if (!isGenderInput(genderInput) || genderInput.checked) return;

    var scope = closestScope(genderInput);
    if (!isMysteryScope(scope)) return;

    // Clear transient cross-option state before the global variant click guard
    // handles this same interaction.
    genderInput.classList.remove('sold-out', 'unavailable');
    genderInput.removeAttribute('disabled');

    var variants = scope.querySelector('[data-product-variants]');
    if (!variants) return;

    var sizeWrapper = variants.querySelector('[data-option-position="2"]');
    if (!sizeWrapper) return;

    var checkedSize = sizeWrapper.querySelector('input[name^="options"][type="radio"]:checked');
    if (!checkedSize) return;

    checkedSize.checked = false;
    checkedSize.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.product__selectors [data-option-position="1"] .radio__button label');
    if (!label) return;

    var wrapper = label.closest('.radio__button');
    var input = wrapper ? wrapper.querySelector('input[type="radio"]') : null;
    resetSizeBeforeGenderSwitch(input);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.matches('.product__selectors [data-option-position="1"] input[type="radio"]')) return;

    resetSizeBeforeGenderSwitch(event.target);
  }, true);

  // Broadcast recalculates availability synchronously on option change. Run after
  // that shared lifecycle and clear transient cross-option states from Mystery
  // Gender only. Size SOLD OUT / UNAVAILABLE states remain untouched.
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.product__selectors input[name^="options"][type="radio"]')) return;

    var scope = closestScope(event.target);
    normalizeGenderAvailability(scope);
  });
})();

/* BDK: prevent interaction with sold-out/unavailable variant buttons */
(function () {
  var MYSTERY_HANDLE = 'mystery-halloween-costume';

  function isMysteryGenderInput(input) {
    if (!input) return false;

    var option = input.closest('[data-option-position="1"]');
    if (!option) return false;

    var scope = input.closest('[data-product-handle], [data-section-type="product"], [data-quick-add-modal]');
    if (!scope) return false;

    if (scope.getAttribute && scope.getAttribute('data-product-handle') === MYSTERY_HANDLE) {
      return true;
    }

    return !!scope.querySelector(
      '[data-product-handle="' + MYSTERY_HANDLE + '"], a[href*="/products/' + MYSTERY_HANDLE + '"]'
    );
  }

  function isBlockedVariantInput(input) {
    if (isMysteryGenderInput(input)) return false;

    return input && (
      input.classList.contains('sold-out') ||
      input.classList.contains('unavailable') ||
      input.disabled
    );
  }

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.product__selectors .radio__button label');
    if (!label) return;

    var wrapper = label.closest('.radio__button');
    var input = wrapper ? wrapper.querySelector('input[type="radio"]') : null;

    if (!isBlockedVariantInput(input)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.matches('.product__selectors .radio__button input[type="radio"]')) return;
    if (!isBlockedVariantInput(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);
})();

/* BADINKA product-card performance helpers: lazy variant images + lazy quick-add modal shell */
(function () {
  if (window.__badinkaProductCardPerfHelpersLoaded) return;
  window.__badinkaProductCardPerfHelpersLoaded = true;

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function hydrateDeferredVariantImage(container) {
    if (!container || container.dataset.deferredVariantImageHydrated === 'true') return;

    var template = container.querySelector('[data-deferred-variant-image-template]');
    if (!template || !template.content) return;

    container.appendChild(template.content.cloneNode(true));
    container.dataset.deferredVariantImageHydrated = 'true';
    template.remove();
  }

  function hydrateVariantForSwatch(swatchButton) {
    if (!swatchButton) return;

    var variantName = swatchButton.getAttribute('data-swatch-variant-name');
    if (!variantName) return;

    variantName = variantName.replaceAll('"', "'");

    var productItem = closest(swatchButton, '[data-grid-item]');
    if (!productItem) return;

    var productImage = productItem.querySelector('[data-product-image]');
    if (!productImage) return;

    var candidates = productImage.querySelectorAll('[data-deferred-variant-image][data-variant-title]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].getAttribute('data-variant-title') === variantName) {
        hydrateDeferredVariantImage(candidates[i]);
        break;
      }
    }
  }

  function htmlEscape(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[char];
    });
  }

  function ensureQuickAddModalTemplate(button) {
    if (!button) return;

    var holder = closest(button, '[data-quick-add-holder]');
    if (!holder || holder.querySelector('[data-quick-add-modal-template]')) return;

    var productId = holder.getAttribute('data-quick-add-holder');
    if (!productId) return;

    var unique = 'QuickAdd-' + productId;
    var template = document.createElement('template');
    template.setAttribute('data-quick-add-modal-template', '');
    template.innerHTML = '' +
      '<dialog class="drawer product-quick-add" data-product-id="' + htmlEscape(productId) + '" data-section-id="' + htmlEscape(unique) + '" inert data-quick-add-modal data-scroll-lock-required>' +
        '<form method="dialog">' +
          '<button class="visually-hidden no-js" aria-label="Close"></button>' +
        '</form>' +
        '<div class="drawer__inner product-quick-add__content" data-product-upsell-container data-scroll-lock-scrollable style="--swatch-size: var(--swatch-size-product)">' +
          '<div class="product-quick-add__close-outer">' +
            '<button class="product-quick-add__close drawer__close" aria-label="Close" data-quick-add-modal-close autofocus>' +
              '<svg aria-hidden="true" focusable="false" role="presentation" width="24" height="24" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
            '</button>' +
          '</div>' +
          '<div class="product-quick-add__inner" data-product-upsell-ajax></div>' +
          '<div class="loader loader--top"><div class="loader-indeterminate"></div></div>' +
        '</div>' +
      '</dialog>';

    holder.appendChild(template);
  }

  document.addEventListener('mouseover', function (event) {
    hydrateVariantForSwatch(closest(event.target, '[data-swatch-button]'));
  }, true);

  document.addEventListener('focusin', function (event) {
    hydrateVariantForSwatch(closest(event.target, '[data-swatch-button]'));
  }, true);

  document.addEventListener('touchstart', function (event) {
    hydrateVariantForSwatch(closest(event.target, '[data-swatch-button]'));
  }, { passive: true, capture: true });

  document.addEventListener('click', function (event) {
    ensureQuickAddModalTemplate(closest(event.target, '[data-quick-add-btn], [data-quick-add-modal-handle]'));
  }, true);
})();




